// extracted by mini-css-extract-plugin
export default {"deleteContainer":"DIuYntbrdD1HdyZkbGnv","iconText":"BCbko27Z28kz1kaQ4aPQ","imgIcon":"zqO24dqol1cnnUGlg6Nc"};